/**
 * This file defines SSO login functions
 */

import { makeRequest } from '@vuukle/utils/dist/es';
import TokenHandler from './TokenHandler';
import { ENV } from '~/config/article/env';

(window as any).vuukleLogin = async (hash?: string): Promise<void> => {
  TokenHandler.setSSOInfo(true);

  if (hash === undefined) {
    TokenHandler.removeToken();
    TokenHandler.fireSSOLogoutListeners();
    return;
  }

  if (typeof hash !== 'string' || (typeof hash === 'string' && hash.trim() === '') || hash === null) {
    // tslint:disable-next-line
    return console.error('[Vuukle] vuukleLogin has been called with invalid argument. Please pass it a string.');
  }

  try {
    const response = await makeRequest('POST', `${ENV.API_URL}/api/v1/Auth/siteLogin`, hash, 'application/json');
    if (response.token) {
      /** This message needs to be sent again because the cookie enable method in CommunicationCreator can not be made static  */
      // this.onLoad((iframeWindow) => iframeWindow.postMessage({ canUseCookies: true, resendMessage: true }));
      TokenHandler.saveToken(response.token);
      TokenHandler.fireTokenListeners(response.token);
    } else {
      throw new Error(`Server response doesn't contain profile token`);
    }
  } catch (err) {
    console.error(`[VUUKLE] SSO Authentication Error:`, err);
  }
};

/** This one hasn't been used anywhere yet. In case it's used we will need to add listeners in TokenHandler for this function as well */
(window as any).vuukleAuthUser = (name: string, email: string) => {
  if (window.location.host && !!window.location.host.match('americanthinker.com')) {
    return;
  }

  if (!name || !email || typeof name !== 'string' || typeof email !== 'string') {
    // tslint:disable-next-line
    console.warn(`⚠️[VUUKLE]: SSO wasn't successful. Please provide valid user details: name: string, email: string`);
    // this.onLoad((iframeWindow) => iframeWindow.postMessage({ authenticateUser: {} }, '*'));
  } else {
    // this.onLoad((iframeWindow) => iframeWindow.postMessage({ authenticateUser: { name, email } }, '*'));
  }
};
